export const mkMessage = (text, duration = 3, type = "good") => {
  const msg = {
    text: text,
    expires: Date.now() + duration * 1000,
    type: type,
  };
  return msg;
};
